import { render, staticRenderFns } from "./select-question-type.vue?vue&type=template&id=58c0ead0&"
import script from "./select-question-type.vue?vue&type=script&lang=js&"
export * from "./select-question-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports